import React, { useState } from "react";
import { ButtonGroup, Button as MuiButton, Menu, MenuItem, styled } from "@mui/material";

import ArrowDropDownIcon from "assets/images/icons/JSX/arrow-down";
import Export from "assets/images/icons/JSX/Export";

const StyledButtonGroup = styled(ButtonGroup)({
    borderRadius: "0.375rem",
    height: "2.5rem",
    maxWidth: "100%",
    boxShadow: "none",
    border: "none",
    "&:hover": {
        boxShadow: "none",
    },
    "& .MuiButton-root": {
        backgroundColor: "#0049c6",
        color: "#fff",
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: "1.125rem",
        border: "none",
        textTransform: "none",
        outline: "none",
        boxShadow: "none",
        boxSizing: "border-box",
        transition: "background-color 0.2s ease-in-out",
        "&:hover": {
            backgroundColor: "#003ba0",
            boxShadow: "none",
            border: "none",
        },
        "&:focus": {
            backgroundColor: "#003ba0",
            boxShadow: "none",
            border: "none",
            outline: "none",
        },
        "&:active": {
            boxShadow: "none",
            border: "none",
        },
        "&:disabled": {
            backgroundColor: "rgba(146, 164, 173, 0.4)",
            pointerEvents: "none",
            opacity: 0.7,
            boxShadow: "none",
            border: "none",
        },
        "&:not(:last-of-type)": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: "none",
            "&:hover": {
                borderRight: "none",
            },
        },
        "&:not(:first-of-type)": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
            "&:hover": {
                borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
            },
        },
    },
});

const StyledMainButton = styled(MuiButton)({
    padding: "0 1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    whiteSpace: "nowrap",
    "& svg": {
        maxWidth: "1.125rem",
        maxHeight: "1.125rem",
    },
});

const StyledDropdownButton = styled(MuiButton)({
    minWidth: "auto",
    flexShrink: 0,
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
        maxWidth: "1.125rem",
        maxHeight: "1.125rem",
    },
});

const StyledMenu = styled(Menu)({
    "& .MuiPaper-root": {
        backgroundColor: "#fff",
        border: "1px solid #62bcf8",
        borderRadius: "0.375rem",
        boxShadow: "0 0.125rem 0.375rem 0 rgba(0, 39, 66, 0.06)",
        marginTop: "0.125rem",
        minWidth: "200px",
        "& .MuiList-root": {
            padding: 0,
        },
    },
});

const StyledMenuItem = styled(MenuItem)({
    padding: "0.5rem",
    borderRadius: "0.25rem",
    fontSize: "0.8125rem",
    lineHeight: "1rem",
    "&:hover": {
        backgroundColor: "#f0f8fd",
        color: "#0049c6",
    },
});

const ExportDataButton = ({
    onExportChartData = () => {},
    onExportRawResults = () => {},
    disabled = false,
    isLoading = false,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleDropdownClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleExportChartData = () => {
        onExportChartData();
    };

    const handleExportRawResults = () => {
        onExportRawResults();
        handleMenuClose();
    };

    return (
        <>
            <StyledButtonGroup disabled={disabled || isLoading}>
                <StyledMainButton onClick={handleExportChartData} disabled={disabled || isLoading}>
                    <Export fill="#fff" />
                    {isLoading ? "Exporting..." : "Export Data"}
                </StyledMainButton>
                <StyledDropdownButton onClick={handleDropdownClick} disabled={disabled || isLoading}>
                    <ArrowDropDownIcon fill="#fff" />
                </StyledDropdownButton>
            </StyledButtonGroup>
            <StyledMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <StyledMenuItem onClick={handleExportRawResults}>Download raw results</StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default ExportDataButton;
